export default __webpack_public_path__ + "static/media/CAP_logo_COMINGSOON_4.1a2eed55.gif";